// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__NQHMt","insightsList":"newBusinessInsightsMenu_insightsList__3cHOc","active":"newBusinessInsightsMenu_active__W8ekF"};